"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrefersReducedMotion = void 0;
var _react = require("react");
const QUERY = "(prefers-reduced-motion: reduce)";
const getInitialState = () => window.matchMedia(QUERY).matches;

/**
 * Returns true if the user prefers reduced motion.
 * It's useful for conditionally disabling animations for users who prefer reduced motion.
 * @returns {boolean} - true if the user prefers reduced motion, false otherwise.
 */
const usePrefersReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = (0, _react.useState)(getInitialState);
  (0, _react.useEffect)(() => {
    const mediaQuery = window.matchMedia(QUERY);
    const listener = event => {
      setPrefersReducedMotion(event.matches);
    };
    mediaQuery.addEventListener("change", listener);
    return () => {
      mediaQuery.removeEventListener("change", listener);
    };
  }, []);
  return prefersReducedMotion;
};
exports.usePrefersReducedMotion = usePrefersReducedMotion;